export const getRemainingPoints = (basket, accountPoints = 0) => {
    if (_.isEmpty(basket) || _.isEmpty(basket?.items_tickets)) return accountPoints

    const allTickets = _.flatMap(basket?.items_tickets, (item) => _.flatMap(item?.tickets))
    const priceToRemove = allTickets?.reduce((acc, val) => {
        if (val?.used_points) return acc + val?.price

        return acc
    }, 0)

    return accountPoints - priceToRemove
}
